import SuggestedRepliesOptionState from './schema/SuggestedRepliesOptionState';
import { createStore } from 'satcheljs';
import '../mutators/discardSuggestedRepliesOption';
import '../mutators/selectSuggestedRepliesOption';
import '../mutators/updateSuggestedRepliesOption';
import '../../orchestration/saveSuggestedRepliesOption';

export default createStore<SuggestedRepliesOptionState>('suggestedRepliesOption', {
    isEnabled: null,
});
